module.exports = __webpack_public_path__ + "img/3.14029742.jpg";